import { Component, computed, Input, signal, WritableSignal } from '@angular/core';
import { IconBellFilledComponent } from '../icon-bell-filled/icon-bell-filled.component';
import { IconBellComponent } from '../icon-bell/icon-bell.component';

@Component({
  selector: 'icon-notification-bell',
  imports: [IconBellComponent, IconBellFilledComponent],
  templateUrl: './icon-notification-bell.component.html',
  styles: ''
})
export class IconNotificationBellComponent {
  @Input() size: number = 24;
  @Input() unreadCount: number = 0;
  @Input() hasNewNotification: boolean = false;
  @Input() shouldAnimate: boolean = false;

  hasUnread = computed(() => this.unreadCount > 0 || this.hasNewNotification);
  private animationSignal: WritableSignal<boolean> = signal(false);
  isAnimating = this.animationSignal.asReadonly();

  // Méthode pour déclencher l'animation
  triggerAnimation(): void {
    this.animationSignal.set(true);
    setTimeout(() => {
      this.animationSignal.set(false);
    }, 600);
  }
}
